import React from "react";
import {
  ProgressWrapper,
  ProgressBarTrack,
  ProgressBarFill,
  StepIndicatorRow,
} from "../registerStyles";

const STEPS_LABELS = [
  "Cuenta Google",
  "Datos Personales",
  "Tu Consultorio",
  "Tipo Clinica",
  "Tu Rol",
  "Tu Equipo",
  "Pacientes",
  "Gestion",
  "Plan Ideal"
];

export const ProgressBar = ({ currentStep, totalSteps = 9 }) => {
  const percent = Math.round(((currentStep + 1) / totalSteps) * 100);

  return (
    <ProgressWrapper>
      <ProgressBarTrack>
        <ProgressBarFill percent={percent} />
      </ProgressBarTrack>
      <StepIndicatorRow>
        <span>Paso {currentStep + 1} de {totalSteps}: {STEPS_LABELS[currentStep] || ""}</span>
        <span>{percent}% completado</span>
      </StepIndicatorRow>
    </ProgressWrapper>
  );
};
